import { IServicesApiState } from '../types/services.types';

export const SERVICES_INITIAL_STATE: IServicesApiState = {
    data: {
        list: [],
        totalPages: 0,
        totalRecords: 0,
    },
    pageProps: {
        isDescending: false,
        pageNumber: 0,
        perPage: 0,
        searchText: '',
        sortingOn: '',
    },
    servicesList: [],
    loading: 'idle',
    error: null,
};
